import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=483a0947"
import script from "../../controllers/exam/exam-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/exam/exam-detail.js?vue&type=script&lang=js&external"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=483a0947&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports